import { pullSessionToken } from "../../services/sessionStorage";
import { getAnonymousStamp } from "../../utils/anonymousStamp";
import { WSQueryCache } from "@ws-react-query";
import {
  experimentFlags,
  QUERY_FEATURE_FLAGS
} from "../../query/hooks/useFeatureFlags";

export const TAX_YEARS = [2025, 2024] as const;
export const OLD_TAX_YEAR = 2023 as const;

export type TaxYear = (typeof TAX_YEARS)[number];

export const DEFAULT_TAX_YEAR: TaxYear = 2024;

export const DOCS_TAX_YEAR = 2025;

// temporary checking for 2025
const getIs2025TaxYearEnabled = (): boolean => {
  const sessionToken = pullSessionToken();
  const anonymousId = getAnonymousStamp();

  const featureFlags = WSQueryCache.getQueryData<typeof experimentFlags>([
    QUERY_FEATURE_FLAGS,
    anonymousId,
    sessionToken
  ]);

  return !!featureFlags?.taxFilingSeason2025;
};

export const getDefaultTaxYear = (): TaxYear => {
  return getIs2025TaxYearEnabled() ? 2025 : DEFAULT_TAX_YEAR;
};

export const getTaxYears = (): TaxYear[] => {
  return getIs2025TaxYearEnabled() ? [2025, 2024] : [2024];
};
